// First, before any module builds a schema (see the file).
import './lib/zod-config.ts'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import './index.css'
import App from './App.tsx'
import { applyBootstrapTheme, bootstrapSkinReady } from './lib/theme/theme-bootstrap.ts'
import { OAUTH_FRAGMENT_KEY, OAUTH_SEARCH_KEY } from './lib/auth/oauth.ts'
import { seedSyncStatus } from './lib/app-services.ts'
import { deleteLegacyCaches, removeDevServiceWorkers } from './lib/pwa/legacy-cleanup.ts'
import { startTabPresence } from './lib/tab-presence.ts'

// Apply the saved theme before anything renders (no flash of the default theme).
applyBootstrapTheme()

// Honest sync status from the first frame (signed out / offline / syncing).
seedSyncStatus()

// PWA: new versions activate on the next navigation. In `vite dev` there is no
// service worker unless VITE_PWA_DEV=1, so remove any an older setup left.
if (import.meta.env.DEV && import.meta.env['VITE_PWA_DEV'] !== '1') void removeDevServiceWorkers()
else registerSW({ immediate: false })
// Authenticated Google responses cached by older builds (lib/pwa/legacy-cleanup.ts).
void deleteLegacyCaches()

// ── OAuth redirect → hash route ──────────────────────────────────────────────
// Google redirects to the real path /auth/callback#access_token=…. The app
// uses a hash router, so the token fragment would be overwritten by the route.
// Keep it in sessionStorage and continue on #/auth/callback.
if (window.location.pathname === '/auth/callback') {
  sessionStorage.setItem(OAUTH_FRAGMENT_KEY, window.location.hash)
  sessionStorage.setItem(OAUTH_SEARCH_KEY, window.location.search)
  window.location.replace('/#/auth/callback')
} else {
  // Other QUIPWA tabs hear this one open and get used (the exam's integrity, lib/tab-presence.ts).
  startTabPresence()
  // A skin's stylesheet before the first frame (a bounded wait: theme-bootstrap.ts).
  void bootstrapSkinReady().then(() => {
    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <App />
      </StrictMode>,
    )
  })
}
